import React from "react";
import { refreshSiteCurrency } from "../lib/money";

export default function SiteCurrencyBootstrap() {
  React.useEffect(() => {
    let cancelled = false;

    const fetchCurrency = async () => {
      try {
        await refreshSiteCurrency();
      } catch {
      }
    };

    fetchCurrency();

    const onVisible = () => {
      if (document.visibilityState === "visible") fetchCurrency();
    };

    document.addEventListener("visibilitychange", onVisible);
    const interval = window.setInterval(fetchCurrency, 5 * 60 * 1000);

    return () => {
      cancelled = true;
      document.removeEventListener("visibilitychange", onVisible);
      window.clearInterval(interval);
      void cancelled;
    };
  }, []);

  return null;
}
